import {z} from 'zod'

export const addIssue = (ctx: z.RefinementCtx, message: string, path: Array<string | number>) => {
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message,
    path
  })
}

export const BoolString = z
  .enum(['true', 'false'])
  .catch('false')
  .transform(v => v === 'true')
